/** @format */

import { ProductStylePrices } from './product-style-prices.interface';

export interface ReadyForNextRoundAddOnCard {
  ecode: string;
  hasListPriceRange: boolean;
  hasOfferPriceRange: boolean;
  imageUrl: string;
  isClearancePrice: boolean;
  isSeePriceInCart: boolean;
  prices: ProductStylePrices;
  title: string;
}
